import React from "react";
import style from './mobileOrderCard.module.scss';
import { Link } from "react-router-dom"
import toPersianNumber from "../../../helpers/actions/toPersianNumber"
import { numberWithCommas } from "../../../helpers/actions/splitNumberWithComma";

const MobileOrderCard = (props) => {

    const convertDate = date => {
        let tmpDate = (new Date(date)).toLocaleDateString("fa-IR")
        tmpDate = tmpDate + ' - ' + (new Date(date)).getHours() + ':' + (new Date(date)).getMinutes();

        return tmpDate
    }

    return (
        <div className={`${style.wrapper} ${props.data.commited_count > 0 ? style.yellowBG : style.greenBG}`}>
            <div className={style.innerWrap}>
                <div className={style.name}>
                    <p
                        className={style.realName}
                        data-content={!props.data.title.split(' | ')[1].includes('گارانتی')
                            &&
                            !props.data.title.split(' | ')[1].includes('تضمین')
                            ?
                            '(' + toPersianNumber(props.data.title.split(' | ')[1]) + ')'
                            :
                            ''}
                    >
                        {toPersianNumber(props.data.title)}
                    </p>
                </div>
                <div className={style.colWrapper}>
                    <div className={style.dataWrapper}>
                        <p className={style.label}>DKPC</p>
                        <p className={style.value}>{toPersianNumber(props.data.dkpc)}</p>
                    </div>

                    <div className={style.dataWrapper}>
                        <p className={style.label}>تاریخ ثبت سفارش</p>
                        <p className={style.value}>{toPersianNumber(convertDate(props.data.order_item_created_at))}</p>
                    </div>

                    <div className={style.dataWrapper}>
                        <p className={style.label}>تاریخ ثبت نهایی</p>
                        <p className={style.value}>{toPersianNumber(convertDate(props.data.warehouse_status_at))}</p>
                    </div>

                    <div className={style.dataWrapper}>
                        <p className={style.label}>تاریخ تعهد ارسال</p>
                        <p className={style.value}>{toPersianNumber(convertDate(props.data.commitment_date))}</p>
                    </div>

                    <div className={style.dataWrapper}>
                        <p className={style.label}>تعداد سفارش</p>
                        <p className={style.value}>{toPersianNumber(props.data.quantity)}</p>
                    </div>

                    <div className={style.dataWrapper}>
                        <p className={style.label}>تعداد تعهد ارسال</p>
                        <p className={style.value}>{toPersianNumber(props.data.commited_count)}</p>
                    </div>
                </div>
            </div>

            {props.data.commited_count > 0 && <div className={style.warning}>
                <div className={style.icon}>n</div>
                <p className={style.warningText}>در این سفارش {toPersianNumber(props.data.commited_count)} تنوع دارای تعهد ارسال به انبار دیجی‌کالا وجود دارد</p>
            </div>}
        </div>
    )
}
export default MobileOrderCard

